<template>
  <div class="bg">
   <login/>
  </div>
</template>

<script>
import login from "../components/login.vue"
export default {
  name: 'HomeView',
  components: {
    login
  }
}
</script>

<style scoped>
/* * {
      margin: 0;
      padding: 0;
  } */
  body {
  height: 100%;
  padding: 0;
  margin: 0;
}
.bg {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: url(@/assets/logo.png) no-repeat;
  background-size: cover;
}
</style>